// merchant-pc 路由 (PR-22a-3 RFC-20260514-010 / PR-comm-4 加 commission-config)
// 路由命名严格对应 prototype merchant_pc.html#m00..#p11 屏 ID (PROJECT_RULES §3.2)

import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'm00-login',
    component: () => import('@/views/m00-login/index.vue'),
    meta: { prototypeRef: 'merchant_pc.html#p01', requiresAuth: false },
  },
  // RFC-20260617-001: merchant self-service onboarding application form
  {
    path: '/apply',
    name: 'm00b-merchant-apply',
    component: () => import('@/views/m00b-merchant-apply/index.vue'),
    meta: { requiresAuth: false },
  },
  // PR-DEMO-1-G-batch1 (2026-05-23): p02 仪表盘 (登录后主屏) + p08 全部订单
  {
    path: '/dashboard',
    name: 'p02-dashboard',
    component: () => import('@/views/p02-dashboard/index.vue'),
    meta: { prototypeRef: 'merchant_pc.html#p02', requiresAuth: true },
  },
  {
    path: '/orders',
    name: 'p08-orders',
    component: () => import('@/views/p08-orders/index.vue'),
    meta: { prototypeRef: 'merchant_pc.html#p08', requiresAuth: true },
  },
  // PR-DEMO-1-H-fix-v4 (2026-05-23): p08a 订单详情 (R-META-7 闭环修)
  {
    path: '/orders/:orderId',
    name: 'p08a-order-detail',
    component: () => import('@/views/p08a-order-detail/index.vue'),
    meta: { prototypeRef: 'merchant_pc.html#p08a', requiresAuth: true },
  },
  // PR-DEMO-1-G-batch2 (2026-05-23): p10 货品列表 + p13 店员管理
  {
    path: '/products',
    name: 'p10-products',
    component: () => import('@/views/p10-products/index.vue'),
    meta: { prototypeRef: 'merchant_pc.html#p10', requiresAuth: true },
  },
  {
    path: '/product-sets',
    name: 'p10-product-sets',
    component: () => import('@/views/p10-product-sets/index.vue'),
    meta: { prototypeRef: 'merchant_pc.html#p10-set', requiresAuth: true },
  },
  {
    path: '/staff',
    name: 'p13-staff',
    component: () => import('@/views/p13-staff/index.vue'),
    meta: { prototypeRef: 'merchant_pc.html#p13', requiresAuth: true },
  },
  // RFC-20260527-001 阶段 4 D3 (2026-05-28): 品牌尺码表 CRUD (无主原型, PM 签布局)
  {
    path: '/brand-sizing',
    name: 'p14-brand-sizing',
    component: () => import('@/views/p14-brand-sizing/index.vue'),
    meta: { requiresAuth: true },
  },
  // PR-DEMO-1-G-batch3 (2026-05-23): p07 推送历史 + p09 批量上传
  {
    path: '/push-history',
    name: 'p07-push-history',
    component: () => import('@/views/p07-push-history/index.vue'),
    meta: { prototypeRef: 'merchant_pc.html#p07', requiresAuth: true },
  },
  {
    path: '/batch-upload',
    name: 'p09-batch-upload',
    component: () => import('@/views/p09-batch-upload/index.vue'),
    meta: { prototypeRef: 'merchant_pc.html#p09', requiresAuth: true },
  },
  // PR-DEMO-1-G-batch4 (2026-05-23): p11 贡献看板 + p12 账单年费
  {
    path: '/contribution',
    name: 'p11-contribution',
    component: () => import('@/views/p11-contribution/index.vue'),
    meta: { prototypeRef: 'merchant_pc.html#p11', requiresAuth: true },
  },
  {
    path: '/billing',
    name: 'p12-billing',
    component: () => import('@/views/p12-billing/index.vue'),
    meta: { prototypeRef: 'merchant_pc.html#p12', requiresAuth: true },
  },
  // PR4-MVP-3-P1 (2026-05-26): 通知中心
  {
    path: '/notifications',
    name: 'notification-center',
    component: () => import('@/views/notification-center/index.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/customer-search-auth',
    name: 'm-customer-search-auth',
    component: () => import('@/views/m-customer-search-auth/index.vue'),
    meta: { prototypeRef: 'merchant_pc.html#m-customer-search-auth', requiresAuth: true },
  },
  {
    path: '/commission-config',
    name: 'm-commission-config',
    component: () => import('@/views/m-commission-config/index.vue'),
    meta: { prototypeRef: 'merchant_pc.html#m-commission-config', requiresAuth: true },
  },
  {
    path: '/review-mgmt',
    name: 'm-review-mgmt',
    component: () => import('@/views/m-review-mgmt/index.vue'),
    meta: { prototypeRef: 'merchant_pc.html#m-review-mgmt', requiresAuth: true },
  },
  // PR2-G2 (2026-05-25) #8: 商户签约搭配师管理
  {
    path: '/signings',
    name: 'm-stylist-signing',
    component: () => import('@/views/m-stylist-signing/index.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/customers',
    name: 'm02-customers',
    component: () => import('@/views/m02-customers/index.vue'),
    meta: { prototypeRef: 'merchant_pc.html#p03', requiresAuth: true },
  },
  {
    path: '/customers/:userId',
    name: 'm02-customer-detail',
    component: () => import('@/views/m02-customer-detail/index.vue'),
    meta: { prototypeRef: 'merchant_pc.html#p04', requiresAuth: true },
  },
];

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

// PR-DEMO-1-I-batch5-cont-fix2 (2026-05-24): beforeEach guard 强校 token + requiresAuth
//   - 防用户手动输 URL 进受保护页 (e.g. /dashboard 没 token 直接进会一直 401 loop)
//   - 复用 api.ts 401 → location.replace('/login') 但增加 router 层面预防
router.beforeEach((to, _from, next) => {
  const requiresAuth = to.meta?.requiresAuth === true;
  let hasToken = false;
  try { hasToken = !requiresAuth || !!localStorage.getItem('auth:token'); }
  catch { /* F47: unreadable credentials follow the existing unauthenticated redirect. */ }
  if (requiresAuth && !hasToken) {
    if (to.path !== '/login') {
      next({ path: '/login', replace: true });
      return;
    }
  }
  next();
});
